export default __webpack_public_path__ + "static/media/project-img-2.31746470.png";